import { Route, Routes } from "react-router-dom";
import AppLayout from "./components/AppLayout/AppLayout";
import AuthGate from "./components/AuthGate/AuthGate";
import AuthError from "./pages/AuthError/AuthError";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import {
  ThemeProvider as AppThemeProvider,
  useTheme,
} from "./contexts/ThemeContext";
import { GlobalStyles } from "./styles/GlobalStyles";
import "./App.css";

function AppContent() {
  const { theme } = useTheme();
  return (
    <StyledThemeProvider theme={theme}>
      <GlobalStyles />
      <Routes>
        {/* Сюда сервер возвращает браузер после неудачного входа — без сессии. */}
        <Route path="/access-denied" element={<AuthError kind="access-denied" />} />
        <Route path="/login-error" element={<AuthError kind="login-error" />} />
        <Route
          path="/*"
          element={
            <AuthGate>
              <AppLayout />
            </AuthGate>
          }
        />
      </Routes>
    </StyledThemeProvider>
  );
}

function App() {
  return (
    <AppThemeProvider>
      <AppContent />
    </AppThemeProvider>
  );
}

export default App;
